import { ROUTES } from '@/constants/routes';
import { Stack } from '@mui/material';
import { SVLink, SVSummaryCard } from '../core';
import { formatDateTimeFromUTC } from '@/utils/date';
import { SVSummaryCardItem } from '@/types/common';
import { StaffMemberDetails } from '@/types/staff';
import StatusLabel from '../StatusLabel';
import { FORM_FIELDS } from '@/constants/formFields';

type StaffDetailsBasicInfoProps = {
  staffDetails: StaffMemberDetails;
};

export default function StaffDetailsBasicInfo({
  staffDetails,
}: StaffDetailsBasicInfoProps) {
  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    businessPhoneNumber,
    title,
    companies,
    avatar,
    bio,
    createdAt,
    lastLoginAt,
    status,
  } = staffDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: FORM_FIELDS.FIRST_NAME.label,
      text: firstName,
    },
    {
      label: FORM_FIELDS.LAST_NAME.label,
      text: lastName,
    },
    {
      label: FORM_FIELDS.EMAIL.label,
      text: email,
    },
    {
      label: FORM_FIELDS.PHONE.label,
      text: phoneNumber,
    },
    {
      label: FORM_FIELDS.BUSINESS_PHONE.label,
      text: businessPhoneNumber,
    },
    {
      label: 'Title',
      text: title,
    },
    {
      label: 'Created Date',
      text: formatDateTimeFromUTC(createdAt),
    },
    {
      label: 'Last Login Date',
      text: lastLoginAt ? formatDateTimeFromUTC(lastLoginAt) : 'N/A',
    },
    {
      label: 'Status',
      customContent: <StatusLabel status={status} />,
    },
    {
      label: 'Companies',
      customContent: companies.length ? (
        <Stack spacing={1}>
          {companies.map(company => (
            <SVLink
              key={company.uuid}
              to={`${ROUTES.COMPANIES}/${company.uuid}`}>
              {company.name}
            </SVLink>
          ))}
        </Stack>
      ) : null,
    },
    {
      label: 'Bio',
      text: bio,
    },
  ];

  return <SVSummaryCard label="Basic Info" items={items} avatar={avatar} />;
}
